<!-- TODO: Add loader after adapter changes are done -->
@if (content.cards) {
  <div class="card-carousel">
    <div class="card-carousel--banner">
      <idp-banner [content]="content.cards[content.current - 1]"></idp-banner>
    </div>
    @if (content.cards.length > 1) {
      <div class="card-carousel--paginator">
        <idp-simple-paginator
          (current)="content.current = $event"
          [content]="content.paginator"
        ></idp-simple-paginator>
      </div>
    }
  </div>
}
